import {
  Button, Form, message, Pagination, Space, Table,
} from 'antd';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import translations from '../../../hooks/translation/translations.json';
import { getPaymentsService, sendPaymentsReportService } from '../../services/paymenSevices';
import { paymentColumns } from '../../../../utils/tableColumns';
import PaymentsSearchForm from '../../forms/PaymentsSearchForm';
import GeneratedPaymentsReportForm from '../../forms/GeneratedPaymentsReportForm';
import useTranslation from '../../../hooks/translation/useTranslation';

function Payments() {
  const { trans } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [data, setData] = useState({
    loading: false,
    data: [],
    meta: null,
    searchState: {},
  });

  const fetchData = async (page, itemsPerPage, values = {}) => {
    setData((prevData) => ({
      ...prevData,
      loading: true,
    }));
    try {
      const res = await getPaymentsService({
        params: {
          page,
          limit: itemsPerPage,
        },
        values,
      });
      setData({
        loading: false,
        data: res.data,
        meta: res.meta,
        searchState: {
          page,
          pageSize: itemsPerPage,
          values,
        },
      });
    } catch (error) {
      setData((prevData) => ({
        ...prevData,
        loading: false,
      }));
    }
  };

  const handleSearch = async (values) => {
    fetchData(
      data?.meta?.currentPage || location?.state?.page || 1,
      data?.meta?.itemsPerPage || location?.state?.pageSize || 10,
      values,
    );
  };

  const handlePageChange = (page, newPageSize) => {
    fetchData(page, newPageSize, form.getFieldsValue());
  };

  const handleSendReport = async (values) => {
    await sendPaymentsReportService(values);
    message.success(
      translations.ka.report_send_text,
    );
  };

  useEffect(() => {
    const page = location?.state?.page || 1;
    const pageSize = location?.state?.pageSize || 10;
    if (location?.state?.values) {
      form.setFieldsValue(location?.state?.values);
    }
    fetchData(page, pageSize, location?.state?.values || {});
    navigate(location.pathname, { replace: true, state: null });
  }, []);

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <div>
        <PaymentsSearchForm onFinish={handleSearch} form={form} />
      </div>
      <div style={{ overflowX: 'auto' }}>
        <Table
          loading={data.loading}
          pagination={false}
          dataSource={data.data.map((payment) => ({
            key: payment?.payment_id,
            payment_date: payment?.payment_date ? moment(payment?.payment_date).format('DD/MM/YYYY HH:mm') : '',
            amount: payment?.amount,
            approval_code: payment?.refunded_approval_code,
            payment_id: payment?.payment_id,
            customer_email: payment?.statement?.customer?.email,
            statement_id: payment?.statement?.statement_id,
            refunded_amount: payment?.refunded_amount,
            details: (
              <Link
                to={`/admin/payments/${payment?.id}`}
                state={data?.searchState}
              >
                <Button>
                  {trans('details')}
                </Button>
              </Link>),
          }))}
          columns={paymentColumns.map(
            (col) => ({
              ...col,
              title: trans(col.title),
            }),
          )}
        />
      </div>
      {data?.meta && (
      <Pagination
        pageSize={+(data?.meta?.itemsPerPage || 10)}
        total={data?.meta?.totalItems}
        current={Number(data?.meta?.currentPage)}
        onChange={handlePageChange}
        onShowSizeChange={handlePageChange}
        showSizeChanger
        pageSizeOptions={['5', '10', '20', '50']}
      />
      )}
      <GeneratedPaymentsReportForm onFinish={handleSendReport} />
    </Space>
  );
}

export default Payments;
